<template>
  <section class="section-hero">
    <div class="hero container" >
      <div class="hero-content" style="margin-bottom: 1rem;">
        <h1 class="heading-primary">
          Learn to Invest by Doing — Not Just Watching
        </h1>
        <p class="hero-description" >
          Research tools, games, and courses — your DIY investing toolkit for mastering real strategies.
        </p>
        <button @click="goToSignup" style="display:flex;flex-direction:column;">
          <span>Start Free — No Credit Card Required &rarr;</span>
        
        </button>

        <!-- <div class="join-flex" style="flex-direction:column">
          <a href="/courses"> Explore our course library.</a>
        </div> -->
        
      </div>
      
      <home-journey-carousel></home-journey-carousel>
      <div class="section-header" style="margin-top:1rem;">
         
          <!-- <span class="subheading">{{$t("tests.title")}}</span> -->
          <!-- <h2 class="heading-secondary"> </h2> -->
          <p class="heading-text" >
            <center>Trusted by student clubs, investment communities and users just like you.</center>
          </p>
        </div>
        <div class="testimonials-container" style="margin-top:1rem;">
              <img class="testimonial-img" src="../../assets/qtrade.png" />
              <img class="testimonial-img" src="../../assets/ivey.jpg" />
              
              <img class="testimonial-img" src="../../assets/odette.png" />
              
              <img class="testimonial-img" src="../../assets/gsic.png" />
              <img class="testimonial-img" src="../../assets/investa.png" />
               <img class="testimonial-img" src="../../assets/bishops.png" />
              <img class="testimonial-img" src="../../assets/diyinvestor.png" />
              <img class="testimonial-img" src="../../assets/nick.jpg" />
             
              
              <img class="testimonial-img" src="../../assets/outlaw.png" />
              
              <img class="testimonial-img" src="../../assets/julie.jpg" />
             
              <img class="testimonial-img" src="../../assets/owen.jpg" />
             
              <img class="testimonial-img" src="../../assets/kamil.jpg" />
              
            
          

        </div>
      <!-- <promo-spot></promo-spot> -->
      
    </div>
  </section>
</template>

<script>
import HomeJourneyCarousel from "./HomeJourneyCarousel.vue";

import { SIGNUP_URL } from "../../config.js";

//import APIService from "../../APIService";
// import PromoSpot from './PromoSpot.vue';

//const LAST_COUNT = 12327;

export default {
  data() {
    return {
      heroSection: "",
      heroContent: "",
      obsOptionsHero: {
        root: null,
        threshold: 0.1,
      },
      currentUserCount: null
    };
  },
  mounted() {
  /*
    APIService.get('/user/count').then(resp => {
        if( resp.data.status == "success") {
          this.currentUserCount = resp.data.theCount;
        } else {
          this.currentUserCount = LAST_COUNT;
        }

        this.$nextTick(() => {
          if( this.$refs.userCounter){
            this.$refs.userCounter.start();
          }
        })
        
      }).catch(err => {
        this.currentUserCount = LAST_COUNT;
        console.log(err);
        this.$nextTick(() => {
          if( this.$refs.userCounter){
            this.$refs.userCounter.start();
          }
        })
      });
      */

    this.heroSection = document.querySelector(".section-hero");
    this.heroContent = document.querySelector(".hero-content");
    // const heroObserver = new IntersectionObserver(
    //   this.revealHero,
    //   this.obsOptionsHero
    // );
    // heroObserver.observe(this.heroSection);
  },
  methods: {
    revealHeroContent() {
      this.heroContent.classList.remove("hidden-content");
    },
    revealHero() {
      this.revealHeroContent();
    },
    goToSignup() {
      window.location.href = SIGNUP_URL;
    }
  },

  components: {
     "home-journey-carousel": HomeJourneyCarousel,
    //"promo-spot": PromoSpot
  },
};
</script>

<style scoped>

.heading-text{
  font-size: 1.8rem;
}

.testimonial-img {
  height: 4rem;
  margin-right: 1.2rem;
  border-radius: 50%;
}
.img-container {
  display: flex;
  align-content: center;
  justify-content: center;
}

.img {
  width: 60%;
}

.section-testimonials {
  transition: all 0.3s ease-in;
}

.hidden {
  transform: translateY(4.8rem);
  opacity: 0;
}

.testimonials-container {
  position: relative;
  /* height: 36rem; */
  text-align: center;
}

.section-hero {
  position: relative;
  padding: 9.6rem 0 9.6rem 0;
  background: linear-gradient(130deg, #fff 0%, #edfff8 70%, #e0f6ed 80%);
  transform: skewY(3deg);
}

.hero {
  /* max-width: 130rem; */
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transform: skewY(-3deg);
  position: relative;
  width: 100% !important;
  max-width: none;
}

.hidden-content {
  transform: translateY(9.6rem);
  opacity: 0;
}

.hero-content {
  transition: all 0.3s ease-in;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* margin-bottom:1.8rem; */
  margin-top:1rem;
}

.heading-primary {
  text-align: center;
  font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
  font-size: 3rem;
}

.hero-description {
  line-height: 1.6;
  margin-bottom: 2.4rem;
  max-width: 100rem;
  color: #333;
  text-align: center;
}

.join-flex {
  margin-top: 2.4rem;
  display: flex;
  align-items: center;
}

.join-users {
  display: flex;
  margin-right: 1.6rem;
}

.join-users img {
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
  border: 3px solid #edfff8;
  margin-right: -0.8rem;
}

.join-text {
  font-size: 1.8rem;
  font-weight: 600;
}

.join-text > span {
  color: rgb(105, 59, 245, 1);
  font-weight: 700;
}

button {
  font-family: inherit;
  cursor: pointer;
  font-weight: 500;
  color: #fff;
  transition: all 0.2s;
  padding: 5px 10px;
  border-radius: 0.8rem;
  background-image: linear-gradient(
    to right,
    rgb(105, 59, 245, 1),
    rgb(105, 59, 245, 0.85),
    rgb(105, 59, 245, 0.7)
  );
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  font-size: 2rem;
}

button:hover {
  box-shadow: 0 0.4rem 3.2rem rgb(105, 59, 245, 0.6);
  transform: scale(1.05);
}

button > svg {
  width: 3.6rem;
  margin-left: 1rem;
  transition: transform 0.3s ease-in-out;
  font-weight: 700;
}

button:hover svg {
  transform: translateX(5px);
}

button:active {
  transform: scale(0.95);
}

/* **************************** */
/* BELOW 1360px (Small desktop/laptop) */
/* **************************** */
@media (max-width: 85em) {
  .hero {
    max-width: 120rem;
  }

  /* .heading-primary {
    font-size: 6rem;
  } */
}

/* **************************** */
/* BELOW 976px (landscape tablets) */
/* **************************** */
@media (max-width: 61em) {
  /* .heading-primary {
    font-size: 5.6rem;
  } */
}

/* **************************** */
/* BELOW 800px (tablet) */
/* **************************** */
@media (max-width: 50em) {
  .hero-content {
    width: 80%;
  }

}

/* **************************** */
/* BELOW 592px (mobile) */
/* **************************** */
@media (max-width: 37em) {
  .heading-primary {
    font-size: 3rem;
  }

  .hero-description {
    width: 100%;
  }
}

/* **************************** */
/* BELOW 496px (mobile) */
/* **************************** */
@media (max-width: 31em) {
  /* .heading-primary {
    font-size: 4.4rem;
  } */

  .hero-content {
    width: 100%;
  }

  button {
    padding: 8px 16px;
  }
}
</style>
